import { render } from "./TickerName.vue?vue&type=template&id=65812d90"
import script from "./TickerName.vue?vue&type=script&lang=js"
export * from "./TickerName.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__